var initMediaGallery = function initMediaGallery() {
  var mediaGallery = document.querySelector('.media-gallery');
  if (!mediaGallery) {
    return;
  }
  var mediaThumbs = mediaGallery.querySelectorAll('.media-gallery__thumb');
  var mediaImage = mediaGallery.querySelector('.media-gallery__image img');
  mediaThumbs.forEach(function (item) {
    item.addEventListener('click', function () {
      var image = item.querySelector('img').dataset.image;
      mediaImage.setAttribute('src', image);
      mediaGallery.querySelector('.media-gallery__image').style.setProperty('--url', "url(".concat(image, ")"));
    });
  });
};
export { initMediaGallery };